export default function StorySlide({
  title = "",
  desc = "",
  mainImg = "",
  backImg = "",
  credit = "",
  link = "#",
}) {
  return (
    <div className="storySlide">
      <div className="storyWrap">
        {/* LEFT CONTENT */}
        <div className="storyLeft">
          <span className="storyGoldTop" />
          <span className="storyGoldLeft" />

          <h2 className="storyTitle">
            {(title || "").split("\n").map((line, i) => (
              <span key={i}>
                {line}
                <br />
              </span>
            ))}
          </h2>

          <p className="storyDesc">{desc}</p>
        </div>

        {/* RIGHT IMAGES */}
        <div className="storyRight">
  {/* Gold frame outside image stack */}
  <span className="storyGoldRight" />
  <span className="storyGoldBottom" />

  <div className="storyImageStack">
    <div className="storyImageBack">
      {backImg ? <img src={backImg} alt="" /> : null}
    </div>

    <div className="storyImageMain">
      {mainImg ? <img src={mainImg} alt="" /> : null}
      {credit ? <span className="storyCredit">{credit}</span> : null}
    </div>
  </div>
</div>
      </div>
    </div>
  );
}
